import { render, staticRenderFns } from "./ProductVideoPreview.vue?vue&type=template&id=50e7f770&scoped=true"
import script from "./ProductVideoPreview.vue?vue&type=script&lang=js"
export * from "./ProductVideoPreview.vue?vue&type=script&lang=js"
import style0 from "./ProductVideoPreview.vue?vue&type=style&index=0&id=50e7f770&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e7f770",
  null
  
)

export default component.exports